<template>
  <div class="c-my-calendar">
    <n-loader :loading="$var('load')" />

    <div class="top">
      <!--      <div class="hint">-->
      <!--        <div v-for="(item, index) in types" :key="index" class="hint-item">-->
      <!--          <div class="circle" :style="'background-color:'+item.color+'; background-image:'+item.color+';'"></div>-->
      <!--          {{ item.title }}-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
    <div class="wrapper flex">
      <div class="left">
        <div class="month">
          <div class="month-prev btn" @click="decrease"><img :src="left" alt=""></div>
          <div class="month-title">{{ months[month] }} {{ year }}</div>
          <div class="month-next btn" @click="increase"><img :src="right" alt=""></div>
        </div>
        <div class="calendar">
          <div class="calendar-title">
            <div v-for="item in day" :key="item.id" class="day">{{ item }}</div>
          </div>
          <div class="wrap">
            <div v-for="(week, index) in calendar()" :key="index" class="week">
              <div
                class="calendar-item"
                :class="{'inactive': !week[1]?.index, 'selected': (compareDate(week[1]?.index)),
                         [getClass(workDays[week[1]?.numY])]: true, }"
                :style="'background-color:'+getColor(workDays[week[1]?.numY])+';'"
                @click.stop="ctrlAdd(getDate(week[1]?.index))">
                <div class="top">{{ week[1]?.index }}</div>
                <div v-show="isShowWorkHours(workDays[week[1]?.numY])" class="bottom">
                  {{ getTime(workDays[week[1]?.numY]) + ' - ' + getTime(workDays[week[1]?.numY], 'end') }}
                </div>
                <div v-if="inSelected(week[1]?.index)" class="selected-icon">
                  <img class="img-selected" :src="imgSelected" alt="">
                </div>
              </div>
              <div
                class="calendar-item"
                :class="{'inactive': !week[2]?.index, 'selected': (compareDate(week[2]?.index)),
                         [getClass(workDays[week[2]?.numY])]: true, }"
                :style="'background-color:'+getColor(workDays[week[2]?.numY])+';'"
                @click.stop="ctrlAdd(getDate(week[2]?.index))">
                <div class="top">{{ week[2]?.index }}</div>
                <div v-show="isShowWorkHours(workDays[week[2]?.numY])" class="bottom">
                  {{ getTime(workDays[week[2]?.numY]) + ' - ' + getTime(workDays[week[2]?.numY], 'end') }}
                </div>
                <div v-if="inSelected(week[2]?.index)" class="selected-icon">
                  <img class="img-selected" :src="imgSelected" alt="">
                </div>
              </div>
              <div
                class="calendar-item"
                :class="{'inactive': !week[3]?.index, 'selected': (compareDate(week[3]?.index)),
                         [getClass(workDays[week[3]?.numY])]: true, }"
                :style="'background-color:'+getColor(workDays[week[3]?.numY])+';'"
                @click.stop="ctrlAdd(getDate(week[3]?.index))">
                <div class="top">{{ week[3]?.index }}</div>
                <div v-show="isShowWorkHours(workDays[week[3]?.numY])" class="bottom">
                  {{ getTime(workDays[week[3]?.numY]) + ' - ' + getTime(workDays[week[3]?.numY], 'end') }}
                </div>
                <div v-if="inSelected(week[3]?.index)" class="selected-icon">
                  <img class="img-selected" :src="imgSelected" alt="">
                </div>
              </div>
              <div
                class="calendar-item"
                :class="{'inactive': !week[4]?.index, 'selected':(compareDate(week[4]?.index)),
                         [getClass(workDays[week[4]?.numY])]: true, }"
                :style="'background-color:'+getColor(workDays[week[4]?.numY])+';'"
                @click.stop="ctrlAdd(getDate(week[4]?.index))">
                <div class="top">{{ week[4]?.index }}</div>
                <div v-show="isShowWorkHours(workDays[week[4]?.numY])" class="bottom">
                  {{ getTime(workDays[week[4]?.numY]) + ' - ' + getTime(workDays[week[4]?.numY], 'end') }}
                </div>
                <div v-if="inSelected(week[4]?.index)" class="selected-icon">
                  <img class="img-selected" :src="imgSelected" alt="">
                </div>
              </div>
              <div
                class="calendar-item"
                :class="{'inactive': !week[5]?.index, 'selected': (compareDate(week[5]?.index)),
                         [getClass(workDays[week[5]?.numY])]: true, }"
                :style="'background-color:'+getColor(workDays[week[5]?.numY])+';'"
                @click.stop="ctrlAdd(getDate(week[5]?.index))">
                <div class="top">{{ week[5]?.index }}</div>
                <div v-show="isShowWorkHours(workDays[week[5]?.numY])" class="bottom">
                  {{ getTime(workDays[week[5]?.numY]) + ' - ' + getTime(workDays[week[5]?.numY], 'end') }}
                </div>
                <div v-if="inSelected(week[5]?.index)" class="selected-icon">
                  <img class="img-selected" :src="imgSelected" alt="">
                </div>
              </div>
              <div
                class="calendar-item"
                :class="{'inactive': !week[6]?.index, 'selected': (compareDate(week[6]?.index)),
                         [getClass(workDays[week[6]?.numY])]: true, }"
                :style="'background-color:'+getColor(workDays[week[6]?.numY])+';'"
                @click.stop="ctrlAdd(getDate(week[6]?.index))">
                <div class="top">{{ week[6]?.index }}</div>
                <div v-show="isShowWorkHours(workDays[week[6]?.numY])" class="bottom">
                  {{ getTime(workDays[week[6]?.numY]) + ' - ' + getTime(workDays[week[6]?.numY], 'end') }}
                </div>
                <div v-if="inSelected(week[6]?.index)" class="selected-icon">
                  <img class="img-selected" :src="imgSelected" alt="">
                </div>
              </div>
              <div
                class="calendar-item"
                :class="{'inactive': !week[0]?.index, 'selected': (compareDate(week[0]?.index)),
                         [getClass(workDays[week[0]?.numY])]: true, }"
                :style="'background-color:'+getColor(workDays[week[0]?.numY])+';'"
                @click.stop="ctrlAdd(getDate(week[0]?.index))">
                <div class="top">{{ week[0]?.index }}</div>
                <div v-show="isShowWorkHours(workDays[week[0]?.numY])" class="bottom">
                  {{ getTime(workDays[week[0]?.numY]) + ' - ' + getTime(workDays[week[0]?.numY], 'end') }}
                </div>
                <div v-if="inSelected(week[0]?.index)" class="selected-icon">
                  <img class="img-selected" :src="imgSelected" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="right">
        <div class="form-wrap">
          <div v-if="Object.keys(selectedDates).length === 0" class="disabled"></div>
          <div class="text">Редактирование дней</div>
          <div v-if="locationPoints.length > 0" class="tabs">
            <div class="tab" :class="{'active': tab === 'data'}" @click="tab = 'data'">Общее</div>
            <div class="tab" :class="{'active': tab === 'branches'}" @click="tab = 'branches'">Точки контроля</div>
          </div>
          <div v-if="tab === 'data'" class="data-place">
            <div class="text">Тип посещения:</div>
            <div>
              <div class="custom-checkbox" @click="changeWorkDayType('normal')">
                <input type="checkbox" :disabled="text" :checked="selectedDayType === 'normal'">
                <div class="checkbox"></div>
                <span class="text">Обычный график</span>
              </div>
              <div class="custom-checkbox" @click="changeWorkDayType( 'free')">
                <input type="checkbox" :disabled="text" :checked="selectedDayType === 'free'">
                <div class="checkbox"></div>
                <span class="text">Свободный график</span>
              </div>
              <div
                class="custom-checkbox"
                @click="changeWorkDayType('transition')">
                <input type="checkbox" :disabled="text" :checked="selectedDayType === 'transition'">
                <div class="checkbox"></div>
                <span class="text">24 часовая смена</span>
              </div>
            </div>
            <div>
              <div v-if="selectedDayType === 'free'" class="custom-checkbox">
                <div class="time-selector-place">
                  План часов на день:
                  <div class="time-selector">
                    <n-input
                      :placeholder="'00'"
                      type="text"
                      class="new-time-input"
                      :maxlength="2"
                      v-bind="$form.input('planH')"
                      @blur="onBlurPad('planH')"
                      @input="onTimeInput('planH', 23)"
                    />
                    :
                    <n-input
                      :placeholder="'00'"
                      type="text"
                      class="new-time-input"
                      :maxlength="2"
                      v-bind="$form.input('planM')"
                      @blur="onBlurPad('planM')"
                      @input="onTimeInput('planM', 59)"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div v-if="!isCompany" class="text">Рабочее время:</div>
            <div v-if="!isCompany" class="selectors">
              <div class="time-selector-place">
                Время начала рабочего дня:
                <div class="time-selector">
                  <n-input
                    :placeholder="'00'"
                    type="text"
                    class="new-time-input"
                    :maxlength="2"
                    v-bind="$form.input('startHours')"
                    @blur="onBlurPad('startHours')"
                    @input="onTimeInput('startHours', 23)"
                  />
                  :
                  <n-input
                    :placeholder="'00'"
                    type="text"
                    class="new-time-input"
                    :maxlength="2"
                    v-bind="$form.input('startMinutes')"
                    @blur="onBlurPad('startMinutes')"
                    @input="onTimeInput('startMinutes', 59)"
                  />
                </div>
              </div>
              <div class="time-selector-place">
                Время окончания рабочего дня:
                <div class="time-selector">
                  <n-input
                    :placeholder="'00'"
                    type="text"
                    class="new-time-input"
                    :maxlength="2"
                    v-bind="$form.input('endHours')"
                    @blur="onBlurPad('endHours')"
                    @input="onTimeInput('endHours', 23)"
                  />
                  :
                  <n-input
                    :placeholder="'00'"
                    type="text"
                    class="new-time-input"
                    :maxlength="2"
                    v-bind="$form.input('endMinutes')"
                    @blur="onBlurPad('endMinutes')"
                    @input="onTimeInput('endMinutes', 59)"
                  />
                </div>
              </div>
            </div>
            <div class="text">Тип:</div>
            <div class="title status">
              <div class="circle" :style="{'background': selectedType.color}" />
              <n-select class="new-select" :text="text" :data="types" :value.sync="selectedType" @select="(v) => changeWorkDay(v, 'type')" />
            </div>
          </div>
          <div v-if="tab === 'branches'" class="data-place">
            <div class="input-place">
              <div class="text">Точки контроля</div>
              <n-select class="new-select" :text="text" :data="locationPoints" :value.sync="selectedLocationPoints" />
            </div>
          </div>
          <div class="button-place">
            <n-button v-if="!text && tab==='data'" @click="save">Сохранить</n-button>
            <n-button v-if="!text && tab==='branches'" @click="attachBranches">Сохранить</n-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import left from 'assets/new/left-dark.svg'
import right from 'assets/new/right-dark.svg'
import imgSelected from 'assets/selected-day-icon.png'

export default {
  name: 'CMyCalendar',
  props: {
    workdays: {
      type: [ Object, Array, ],
      required: true,
    },
    text: {
      type: Boolean,
      default: false,
    },
    locationPoints: {
      type: Array,
      default: () => {
        return []
      },
    },
    dbclick: {
      type: Boolean,
      default: false,
    },
    types: {
      type: Array,
      required: true,
    },
    date: {
      type: Date,
      default: () => new Date(),
    },
    isUser: {
      type: Boolean,
      default: true,
    },
    isCompany: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tab: 'data',
      left,
      right,
      imgSelected,
      month: new Date().getMonth(),
      year: new Date().getFullYear(),
      selectedDates: {},
      localeDay: {
        ru: [ 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс', ],
        kz: [ 'Дс', 'Сс', 'Ср', 'Бс', 'Жм', 'Сн', 'Жс', ],
      },
      dateForView: '',
      day: [],
      cDate: new Date,
      localeMonths: {
        ru: [ 'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь', ],
        kz: [ 'Қаңтар', 'Ақпан', 'Наурыз', 'Сәуір', 'Мамыр', 'Маусым', 'Шілде', 'Тамыз', 'Қыркүйек', 'Қазан', 'Қараша', 'Желтоқсан', ],
      },
      months: [],
      dlast: new Date(this.year, this.month + 1, 0).getDate(),
      isOpen: false,
      workDays: this.workdays,
      ctrlPressed: false,
      hours: [],
      minutes: [],
      startMinutes: 0,
      endMinutes: 0,
      planM: null,
      planH: null,
      startHours: 0,
      endHours: 0,
      selectedType: {},
      selectedDayType: 'normal',
      selectedLocationPoints: [],
    }
  },
  computed: {
    selectedHours() {
      const selected = {}
      if (Object.keys(this.selectedDates).length === 1) {
        const item = this.workDays[this.getNumberOfDay(new Date(this.selectedDates[Object.keys(this.selectedDates)[0]]))]
        selected.startHours = $n.filter(this.hours, (e) => {
          if (String(e.value) === String(item?.startHours)) {
            return e
          }
        })[0]
        selected.startMinutes = $n.filter(this.minutes, (e) => {
          if (String(e.value) === String(item?.startMinutes)) {
            return e
          }
        })[0]
        selected.endHours = $n.filter(this.hours, (e) => {
          if (String(e.value) === String(item?.endHours)) {
            return e
          }
        })[0]
        selected.endMinutes = $n.filter(this.minutes, (e) => {
          if (String(e.value) === String(item?.endMinutes)) {
            return e
          }
        })[0]
        selected.planM = $n.filter(this.minutes, (e) => {
          if (String(e.value) === String(item?.planM)) {
            return e
          }
        })[0]
        selected.planH = $n.filter(this.minutes, (e) => {
          if (String(e.value) === String(item?.planH)) {
            return e
          }
        })[0]
      }

      return selected
    },
    sheetIds() {
      return $n.map(this.selectedDates, (e) => {
        return this.workDays[this.getNumberOfDay(e)].id
      })
    },
  },
  watch: {
    selectedDates() {
      if (Object.keys(this.selectedDates).length === 1) {
        const workDay = this.workDays[this.getNumberOfDay(this.selectedDates[Object.keys(this.selectedDates)[0]])]
        const type = workDay.type
        this.selectedDayType = workDay.dayType
        this.selectedType = $n.filter(this.types, (e) => {
          if (type === e.value) {
            return e
          }
        })[0]
        if (!this.selectedType) {
          if ([ 'none', 'work', '1', undefined, ].includes(type)) {
            this.selectedType = { title: 'Рабочий день', value: '', color: '#ffffff', }
          }
        }
        this.selectedLocationPoints = workDay.locationPoints
      } else {
        this.selectedType = {}
        this.selectedDayType = 'normal'
        this.selectedLocationPoints = []
      }
    },
    selectedHours() {
      this.$form.init({
        startMinutes: this.selectedHours?.startMinutes,
        endMinutes: this.selectedHours?.endMinutes,
        startHours: this.selectedHours?.startHours,
        endHours: this.selectedHours?.endHours,
        planM: this.selectedHours?.planM,
        planH: this.selectedHours?.planH,
      })
    },
    workdays() {
      this.workDays = this.workdays
      // this.updateView()
    },
    cDate() {
      // this.updateView()
    },
  },
  created() {
    this.generateHours()
    this.init()
  },
  methods: {
    onTimeInput(field, max) {
      let value = this.$form.get(field) || ''

      value = value.replace(/\D/g, '0')

      if (value.length > 2) {
        value = value.slice(0, 2)
      }

      const num = parseInt(value || '0')

      if (!isNaN(num) && num > max) {
        value = max.toString().padStart(2, '0')
      }

      this.$form.set(field, value)

      this.changeWorkDay(value, field)
    },
    onBlurPad(field) {
      const val = this.$form.get(field)
      if (val !== undefined && val !== null && val.length === 1) {
        const padded = val.padStart(2, '0')
        this.$form.set(field, padded)

        this.changeWorkDay({ value: padded }, this.extractFieldKey(field))
      }
    },
    extractFieldKey(field) {
      return field.split('.').pop()
    },
    changeWorkDayTypeCustom(type) {
      this.selectedType = type
      this.changeWorkDay(type, 'type')
    },
    getTime(item, timeType = 'start') {
      if (item) {
        if (timeType === 'start') {
          return item.startHours + ':' + item.startMinutes
        } else {
          return item.endHours + ':' + item.endMinutes
        }
      }
      return ''
    },
    generateHours() {
      this.hours = Array.from({ length: 24, }, (_, i) => ({
        value: Number(i) > 9 ? i+'' : '0' + (i),
        title: Number(i) > 9 ? i+'' : '0' + (i),
      }))
      this.minutes = Array.from({ length: 60, }, (_, i) => ({
        value: Number(i) > 9 ? i+'' : '0' + (i),
        title: Number(i) > 9 ? i+'' : '0' + (i),
      }))
    },
    isShowWorkHours(item) {
      return [ 'was', 'wasnt', 'late', 'work', '', 'none', '1', 'wasInWeekend', ].includes(item?.type) && !this.isCompany
    },
    ctrlAdd(date) {
      if (this.selectedDates[$app.date.format(date, 'date')]) {
        const obj = { ...this.selectedDates, }
        delete obj[$app.date.format(date, 'date')]
        this.selectedDates = obj
      } else {
        this.selectedDates = {
          ...this.selectedDates,
          [$app.date.format(date, 'date')]: date,
        }
      }
    },
    inSelected(day) {
      if (day) {
        const date = this.getDate(day)
        return !!this.selectedDates[$app.date.format(date, 'date')]
      }
    },
    getColor(value) {
      if (this.isUser) {
        value = value?.type
      }
      const type = $n.filter(this.types, (e) => {
        if (e.value === value) {
          return e
        }
      })
      return type[0]?.color || '#ffffff'
    },
    getClass(value) {
      if (this.isUser) {
        value = value?.type
      }
      const type = $n.filter(this.types, (e) => {
        if (e.value === value) {
          return e
        }
      })
      return type[0]?.class || ''
    },
    save() {
      let workDays = {}
      if (this.isUser) {
        $n.each(this.workDays, (e, i) => {
          if (i > 0) {
            if (Number(i) <= 366) {
              workDays = {
                ...workDays,
                [Number(i)]: e,
              }
            }
          }
        })
        this.$emit('update:workdays', workDays)
      } else {
        this.$emit('update:workdays', this.workDays)
      }
      this.$emit('ready')
      this.selectedDates = {}
      this.$form.reset()
    },
    attachBranches() {
      this.$var('load', true)
      $api.sheets.attachBranches({ sheetIds: this.sheetIds, locationPoints: this.selectedLocationPoints, }).then(() => {
        this.$emit('reloadSheet')
        this.selectedDates = {}
      }).finally(() => {
        this.$var('load', false)
      })
    },
    changeWorkDay(value, field) {
      // Если value — это объект от n-select
      if (value && typeof value === 'object' && value.value) {
        value = value.value
      }

      if (Object.keys(this.selectedDates).length > 0) {
        $n.each(this.selectedDates, (e) => {
          this.workDays = {
            ...this.workDays,
            [this.getNumberOfDay(e)]: {
              ...this.workDays[this.getNumberOfDay(e)],
              [field]: value,
            },
          }
        })
      }

      this.updateView()
    },
    changeWorkDayType(value) {
      if (!this.text) {
        if (Object.keys(this.selectedDates).length > 0) {
          $n.each(this.selectedDates, (e) => {
            this.workDays = {
              ...this.workDays,
              [this.getNumberOfDay(e)]: {
                ...this.workDays[this.getNumberOfDay(e)],
                dayType: value,
              },
            }
          })
          this.selectedDayType = value
        }
      }
    },
    init() {
      const lang = $app.store.getter('app.lang') || 'ru'
      this.months = this.localeMonths[lang]
      this.day = this.localeDay[lang]
      this.cDate = this.date
      this.month = this.cDate.getMonth()
      this.year = this.cDate.getFullYear()
      this.updateView()
    },
    updateView() {
      if (this.cDate) {
        this.dateForView = {
          date: (this.cDate.getDate() <= 9 ? '0' + this.cDate.getDate() : this.cDate.getDate()) +
              ' ' + this.months[this.month].substr(0, 3) + '. ' + this.year,
          value: this.isUser ? this.workDays[this.getNumberOfDay(this.cDate)]?.type : this.workDays[this.getNumberOfDay(this.cDate) - 1],
        }
        this.selectedBranches = this.workDays[this.getNumberOfDay(this.cDate)]?.branches || []
      }
    },
    getDate(day) {
      if (day) {
        return new Date(this.year, this.month, day)
      }
    },
    compareDate(day, sign = '=') {
      if (this.cDate) {
        if (sign === '=') {
          return $app.date.format(this.cDate, 'date', true) === $app.date.format(new Date(this.year, this.month, day), 'date', true)
        } else {
          if (sign === '>=') {
            return $app.date.format(this.cDate, 'date', true) >= $app.date.format(new Date(this.year, this.month, day), 'date', true)
          } else {
            return $app.date.format(this.cDate, 'date', true) <= $app.date.format(new Date(this.year, this.month, day), 'date', true)
          }
        }
      }
    },
    getNumberOfDay(today) {
      const startOfYear = new Date(today.getFullYear(), 0, 0)
      const diff = today - startOfYear

      const oneDay = 1000 * 60 * 60 * 24
      return Math.floor(diff / oneDay)
    },
    calendar: function() {
      let weeks = {}
      let week = 0
      let days = {}
      const dlast = new Date(this.year, this.month + 1, 0).getDate()

      for (let i = 1; i <= dlast; i++) {
        if (!this.isUser) {
          days = {
            ...days,
            [new Date(this.year, this.month, i).getDay()]: {
              index: i,
              numY: Number(this.getNumberOfDay(new Date(this.year, this.month, i)) - 1),
            },
          }
        } else {
          days = {
            ...days,
            [new Date(this.year, this.month, i).getDay()]: {
              index: i,
              numY: Number(this.getNumberOfDay(new Date(this.year, this.month, i))),
            },
          }
        }
        if (new Date(this.year, this.month, i).getDay() === 0) {
          weeks = {
            ...weeks,
            [week]: days,
          }
          week += 1
          days = {}
        }
      }
      if (Object.keys(days).length !== 0) {
        weeks = {
          ...weeks,
          [week]: days,
        }
      }

      return weeks
    },
    decrease() {
      this.month--
      if (this.month < 0) {
        this.month = 12
        this.month--
        this.year--
        this.$emit('update:year', this.year)
      }
    },
    increase() {
      this.month++
      if (this.month > 11) {
        this.month = -1
        this.month++
        this.year++
        this.$emit('update:year', this.year)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.c-my-calendar {

  background-color: #FFFFFF;
  border-radius: 12px;
  padding: 30px;

  .input-place {
    display: flex;
    align-items: center;

    .text {
      width: 120px;
      margin-right: 10px;
    }
  }

  :deep() {
    .n-select {
      .vs__dropdown-menu {
        max-height: 140px;
      }

      .vs__selected {
        font-size: 16px;
        font-weight: normal;
      }

      .vs__dropdown-option {
        font-weight: normal;
      }
    }
  }

  .tabs {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;

    .tab {
      padding: 5px;
      margin-right: 10px;
      border-radius: 12px;
      background-color: #ebebeb;
      width: 150px;
      text-align: center;

      &.active {
        background-color: var(--primary);
        color: #ffffff;
      }

      &:last-child {
        margin-right: 0;
      }
    }
  }

  .calendar-item {
    position: relative;

    .selected-icon {
      position: absolute;
      left: calc(50% - 20px);
      top: 25px;
    }

    .img-selected {
      width: 40px;
      height: 40px;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }

  .title {
    font-size: 16px;
    color: #000000;
    font-weight: 500;

    &.main {
      margin-bottom: 15px;
    }
  }

  .status {
    margin: 5px 0;
    display: flex;
    align-items: center;

    .circle {
      width: 16px;
      height: 16px;
      border-radius: 50%;
      border: 0.5px solid #000000;
      margin-right: 10px;
    }
  }

  .wasInWeekend {
    background-image: linear-gradient(315deg, #64C038 45%, #CFCECE 55%);
  }

  .new-time-input {
    width: 50px !important;
    border-radius: 12px;
    text-align: center;
    box-shadow: 0 0 0 1px #e0e3f0;
    margin: 0 2px;

    ::v-deep {
      .n-input {
        border: none !important;
      }

      .n-content {
        width: 50px;
        height: 40px;
        padding: 6px 10px 6px 15px;
      }
    }
  }

  .time-selector {
    display: flex;
    align-items: center;
    justify-content: start;

    :deep() {
      .n-select {
        .vs__dropdown-toggle {
          border: none;
          border-radius: 12px;
        }
        .n-icon {
          display: none;
        }

        .n-text {
          text-align: center;
        }

        &:first-child {
          margin-right: 5px;
        }

        &:last-child {
          margin-left: 5px;
        }

        width: 60px;

        .n-content {
          padding: 0;
        }

        .n-icon {
          margin: 0 !important;
        }

        .n-popup-content {
          width: 60px;

          .n-dropdown-item {
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .n-item {
            text-align: center;
          }
        }

        .n-wrapper {
          padding: 0 5px;
          width: 60px;
        }

        .n-dropdown {
          width: 60px;
        }
      }
    }
  }

  .time-selector-place {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;

    .time-selector {
      margin-left: 10px;
    }
  }

  .button-place {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .n-tabs {
    justify-content: center;
    margin-top: 20px;

    &::v-deep {
      & > .n-tab {
        margin: 0 14px;
        padding: 0;
        color: #000000;
        cursor: pointer;
        flex-shrink: 0;
        min-width: 250px;
        min-height: 40px;
        font-size: 1em;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 3px solid var(--primary);
        border-radius: 24px;
        background-color: #FFFFFF;

        &.active {
          background: var(--primary);
          border: 3px solid var(--primary);
          color: #fff;
        }
      }
    }
  }

  .wrapper {
    min-height: 400px;
    height: 525px;

    &.flex {
      display: flex;
      align-items: stretch;
      height: 100%;

      .left {
        .n-button {
          margin-top: 20px;
          min-width: 240px;
          color: #FFFFFF;
          border: 3px solid var(--primary);
          border-radius: 24px;
          background-color: var(--primary);
        }
        margin-right: 40px;
        height: 100%;
        flex: 1;
      }

      .right {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        flex: 0.45;

        .n-button {
          margin-top: 20px;
          min-width: 240px;
          color: #FFFFFF;
          border: 3px solid var(--primary);
          border-radius: 12px;
          height: 48px;
          background-color: var(--primary);
        }
      }
    }
  }

  .title {
    font-weight: 700;
    font-size: 16px;
    color: #000;
    margin-bottom: 18px;
  }

  .item {
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    & + .title {
      margin-top: 30px;
    }

    &-title {
      font-weight: 400;
      font-size: 16px;
      color: #000;
      width: 180px;
    }

    &-text {
      background: #FFFFFF;
      border: 1px solid #8A8888;
      border-radius: 2px;
      width: 490px;
      padding: 0 12px;
      display: flex;
      align-items: center;
      height: 30px;
      position: relative;
    }
  }

  .change-color {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;

    &::after {
      content: '';
      position: absolute;
      right: 20px;
      top: 50%;
      transform: translate(0, -50%);
      width: 0;
      height: 0;
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      border-top: 8px solid var(--primary);
    }
  }

  .n-input {
    width: 490px;
  }

  .logo {
    width: 100px;

    img {
      max-width: 100%;
    }
  }


  .buttons {
    margin: 40px 0 15px;
    display: flex;
    align-items: center;
    justify-content: center;


    .n-button {
      min-width: 240px;
      color: #FFFFFF;
      border: 3px solid var(--primary);
      border-radius: 12px;
      height: 48px;
      background-color: var(--primary);

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .hint {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    flex-wrap: wrap;

    &-item {
      font-weight: 400;
      font-size: 16px;
      color: #000;
      display: flex;
      align-items: center;
      margin-right: 30px;
      width: 33.3333333%;

      &:last-child {
        margin-right: 0;
      }
    }

    .circle {
      margin-right: 8px;
      border-radius: 50%;
      width: 20px;
      height: 20px;
      background: #FFF;
      border: 1px solid #CFCECE;

      &.green {
        background: #64C038;
        border: 1px solid #64C038;
      }
    }
  }

  .week {
    display: flex;
    align-items: center;
  }

  .calendar {

    &-title {
      display: flex;
      margin-bottom: 8px;

      .day {
        background-color: #E7EDFF;
        width: calc(100%/7.5);
        font-weight: 700;
        font-size: 16px;
        color: #1B1A1A;
        border-radius: 8px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 4px;
      }
    }

    &-item {
      padding: 5px;
      width: calc(100%/7.5);
      height: 105px;
      border: 1px solid #E7EDFF;
      border-radius: 15px;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      margin-right: 4px;
      margin-bottom: 4px;

      .bottom {
        display: flex;
        align-items: center;
        justify-content: right;
        font-size: 15px;
      }

      &.vac {
        background-color: #64C038;
      }

      &.selected {
        border: 3px solid var(--primary);
      }

      &.inactive {
        background-color: #FFFFFF !important;
        border: 1px solid #B1B1B1;
      }
    }
  }

  .month {
    margin-bottom: 20px;
    border-radius: 8px;
    width: 100%;
    height: 45px;
    font-weight: 700;
    font-size: 24px;
    line-height: 20px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    color: #062D43;

    .btn {
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
  }

  .form-wrap {
    position: relative;
    margin-top: 65px;
    padding: 20px;
    box-shadow: 1px 2px 8px rgb(0 0 0 / 15%);
    border-radius: 12px;
    min-width: 430px;
    background-color: #f1f4fb;
    height: 100%;
    width: 100%;

    .disabled {
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      background: rgba(241, 244, 251, 0.7);
      backdrop-filter: blur(1px);
      z-index: 998;
    }

    & > .text {
      margin-bottom: 20px;
    }

    .text {
      font-weight: 400;
      font-size: 16px;
      color: #000;
    }
  }

  .custom-checkbox {
    position: relative;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    cursor: pointer;

    &:last-child {
      margin-bottom: 0;
    }

    input[type="checkbox"] {
      position: absolute;
      bottom: 0;
      right: 0;
      top: 0;
      left: 0;
      opacity: 0;
      width: 100%;
      height: 100%;

      &:checked {
        & + .checkbox {
          background: #64C038;
        }
      }
    }

    .checkbox {
      margin-right: 15px;
      width: 20px;
      flex-shrink: 0;
      height: 20px;
      background: #FFF;
      border-radius: 50%;
      border: 1px solid #CFCECE;
      transition: all .3s ease-in-out;
    }
  }
}
</style>
